import { Pipe, PipeTransform } from '@angular/core';
import { AcceptedImages, AcceptedAnimatedImages, AcceptedVideos } from '@shared/constants/constants';
import { ContentMediaType } from '@shared/enums/ContentMediaType';

@Pipe({ name: 'fileAccept'})
export class FileAcceptPipe implements PipeTransform {

  public transform(type: ContentMediaType): string {
    let accept;
    switch (type) {
      case ContentMediaType.Image:
        accept = AcceptedImages;
        break;
      case ContentMediaType.AnimatedImage:
        accept = AcceptedAnimatedImages;
        break;
      case ContentMediaType.Video:
        accept = AcceptedVideos;
        break;
    }
    return accept;
  }
}
